import React, {useContext} from 'react';

import{
  Navigate,
  useRoutes
} from "react-router-dom";

// layouts
import DashboardLayout from './layouts/dashboard';
//
import Login from './pages/Login';
import DashboardApp from './pages/DashboardApp';
// Cliente
import CadastroCliente from './pages/Cliente/CadastroCliente';
import ConsultaCliente from './pages/Cliente/ConsultaCliente';
import EditarCliente from './pages/Cliente/EditarCliente';
// Fornecedor
import CadastroFornecedor from './pages/Fornecedor/CadastroFornecedor';
import ConsultaFornecedor from './pages/Fornecedor/ConsultaFornecedor';
import EditarFornecedor from './pages/Fornecedor/EditarFornecedor';
// Produto/Seviço
import CadastroProduto from './pages/Produto/CadastroProduto';
import ConsultaProduto from './pages/Produto/ConsultaProduto';
import EditarProduto from './pages/Produto/EditarProduto';
// Imagem Produto
import ConsultaImagensProduto from './pages/Produto/ImagemProduto/ConsultaImagensProduto';

// Despesa
import CadastroDespesa from './pages/Despesa/CadastroDespesa';
import ConsultaDespesa from './pages/Despesa/ConsultaDespesa';
import EditarDespesa from './pages/Despesa/EditarDespesa';
import DespesaVenda from './pages/Despesa/DespesaVenda';
// Tipo Despesa
import CadastroTipoDespesa from './pages/Despesa/TipoDespesa/CadastrarTipoDespesa';
// Venda
import CadastroVenda from './pages/Venda/CadastroVenda';
import ConsultaVenda from './pages/Venda/ConsultaVenda';
import EditarVenda from './pages/Venda/EditarVenda';
// Venda Avulsa
import ConsultaVendaAvulsa from './pages/VendaComercio/VendaAvulsa';
import ConsultaVendaAvulsaGeral from './pages/VendaComercio/VendaAvulsaGeral';
import ItensVendaAvulsaGeral from './pages/VendaComercio/ItensVenda';
// Mesa
import CadastroMesa from './pages/Mesa/CadastroMesa';
import ConsultaMesa from './pages/Mesa/ConsultaMesa';
import EditarMesa from './pages/Mesa/EditarMesa';
// Usuários
import ConsultaUsuario from './pages/Usuario/ConsultaUsuario';
import EditarUsuario from './pages/Usuario/EditarUsuario';
// Empresa
import CadastroEmpresa from './pages/Empresa/CadastroEmpresa';
import ConsultaEmpresa from './pages/Empresa/ConsultaEmpresa';
import EditarEmpresa from './pages/Empresa/EditarEmpresa';

// Venda Comercio
import CadastroVendaMesa from './pages/VendaComercio/CadastroVendaMesa';
import VendaPorMesa from './pages/VendaComercio/VendaPorMesa';

import { ImprimirEtiqueta } from './utils/impressao/Imprimir';

import NotFound from './pages/Page404';
import Register from './pages/Register';

// ----------------------------------------------------------------------
import { AuthContext } from "./contexts/auth";

const AppRoutes = () => {
  let linkHome; 
  const Private = ({children}) =>{
    const { authenticated, loading } = useContext(AuthContext);

    if (loading){
        return <div className='loading'>Carregando...</div>
    }

    if (!authenticated){
        return <Navigate to="/login"/>
    }

    return children
  } 

   const validaMenuRestrito = localStorage.getItem(['menu_restrito']);
   const menuRestrito = parseInt(validaMenuRestrito, 10);
   
   if (menuRestrito === 1) {
     linkHome = '/venda/consultar';
   }else{
     linkHome = '/indicadores/app';
   }

   return useRoutes([
    {
      path: '/indicadores',
      element: <DashboardLayout />,
      children: [
        { path: 'app', element: <Private><DashboardApp/></Private> },
        { path: '*', element: <Private><DashboardApp/></Private> },
      ],
    },
    {
      path: '/venda',
      element: <DashboardLayout />,
      children: [
        { path: 'cadastrar', element: <Private><CadastroVenda /></Private>},
        { path: 'consultar', element: <Private><ConsultaVenda /></Private>},
        { path: 'editar/:id', element: <Private><EditarVenda /></Private>},
        { path: 'imprimir', element: <Private><ImprimirEtiqueta /></Private>},
      ],
    },
    {
      path: '/venda_comercio',
      element: <DashboardLayout />,
      children: [
        { path: 'consultar/:id', element: <Private><CadastroVendaMesa /></Private>},
        { path: 'venda_por_mesa', element: <Private><VendaPorMesa /></Private>},
      ],
    },
    {
      path: '/venda_avulsa',
      element: <DashboardLayout />,
      children: [
        { path: 'consultar', element: <Private><ConsultaVendaAvulsa /></Private>},
      ],
    },
    {
      path: '/venda_avulsa_geral',
      element: <DashboardLayout />,
      children: [
        { path: 'consultar', element: <Private><ConsultaVendaAvulsaGeral /></Private>},
        { path: 'itens/:id', element: <Private><ItensVendaAvulsaGeral /></Private>},
      ],
    },
    {
      path: '/mesa',
      element: <DashboardLayout />,
      children: [
        { path: 'cadastrar', element: <Private><CadastroMesa /></Private>},
        { path: 'consultar', element: <Private><ConsultaMesa /></Private>},
        { path: 'editar/:id', element: <Private><EditarMesa /></Private>},
      ],
    },
    {
      path: '/cliente',
      element: <DashboardLayout />,
      children: [
        { path: 'cadastrar', element: <Private><CadastroCliente /></Private>},
        { path: 'consultar', element: <Private><ConsultaCliente /></Private>},
        { path: 'editar/:id', element: <Private><EditarCliente /></Private>},
      ],
    },
    {
      path: '/fornecedor',
      element: <DashboardLayout />,
      children: [
        { path: 'cadastrar', element: <Private><CadastroFornecedor /></Private>},
        { path: 'consultar', element: <Private><ConsultaFornecedor /></Private>},
        { path: 'editar/:id', element: <Private><EditarFornecedor /></Private>},
      ],
    },
    {
      path: '/produto',
      element: <DashboardLayout />,
      children: [
        { path: 'cadastrar', element: <Private><CadastroProduto /></Private>},
        { path: 'consultar', element: <Private><ConsultaProduto /></Private>},
        { path: 'editar/:id', element: <Private><EditarProduto /></Private>},
      ],
    },
    {
      path: '/imagens_produto',
      element: <DashboardLayout />,
      children: [
        { path: 'visualizar/:id', element: <Private><ConsultaImagensProduto /></Private>},
      ],
    },
    {
      path: '/despesa',
      element: <DashboardLayout />,
      children: [
        { path: 'cadastrar', element: <Private><CadastroDespesa /></Private>},
        { path: 'consultar', element: <Private><ConsultaDespesa /></Private>},
        { path: 'editar/:id', element: <Private><EditarDespesa /></Private>},
        { path: 'despesas_venda/:id', element: <Private><DespesaVenda /></Private>},
      ],
    }, 
    {
      path: '/tipo_despesa',
      element: <DashboardLayout />,
      children: [
        { path: 'consultar', element: <Private><CadastroTipoDespesa /></Private>},
      ],
    }, 
    {
      path: '/usuarios',
      element: <DashboardLayout />,
      children: [
        { path: 'consultar', element: <Private><ConsultaUsuario /></Private>},
        { path: 'editar/:id', element: <Private><EditarUsuario /></Private>},
      ],
    },
    {
      path: '/empresas',
      element: <DashboardLayout />,
      children: [
        { path: 'cadastrar', element: <Private><CadastroEmpresa /></Private>},
        { path: 'consultar', element: <Private><ConsultaEmpresa /></Private>},
        { path: 'editar/:id', element: <Private><EditarEmpresa /></Private>},
      ],
    },  
    {
      path: '/',
      children: [
        { path: '/', element: <Private><Navigate to={linkHome} /></Private> },
        { path: 'login', element: <Login /> },
        { path: 'register', element: <Register />},
        { path: '404', element: <Private><NotFound /></Private> },
        { path: '*', element: <Private><Navigate to="/404" /></Private> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> }, 
  ]); 
};

export default AppRoutes;
